type Messages = { [K: string]: string };

const DEFAULT_LOCALE = 'en-US';
const FALLBACK = {};

export default async function getLocaleMessages(locale: string): Promise<Messages> {
  if (locale === DEFAULT_LOCALE) {
    // Default locale will use the default fallback strings
    return FALLBACK;
  }
  try {
    const webassetsTranslationsModule: Messages = await import(
      /* webpackChunkName: "i18n/webassets/[request]" */ `@sm/webassets/dist/locales/translated/${locale}`
    );
    const appTranslationsModule: Messages = await import(
      /* webpackChunkName: "i18n/[request]" */ `../../locales/translated/${locale}`
    );
    return {
      ...webassetsTranslationsModule,
      ...appTranslationsModule,
    };
  } catch (err: unknown) {
    return FALLBACK;
  }
}
